// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToggleSwitcher_wrapper__1wWrw","input":"ToggleSwitcher_input__1E3Vn","input_fake":"ToggleSwitcher_input_fake__2UoBN"};